module.exports = "tr td:last-child{vertical-align:middle}.previewButton{cursor:pointer;vertical-align:text-bottom}.telegram-import{margin-bottom:15px}"